// extracted by mini-css-extract-plugin
export default {"primaryColor":"#004aad","primaryColorWithAlpha":"rgba(0,74,173,.1019607843)","mainBgColor":"#004aad","secondBgColor":"#ebebeb","blackColor2":"#1f1f1f"};